"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var Feature = /*#__PURE__*/function () {
  function Feature(name, activationCode, userId, userPassword, additionalData) {
    (0, _classCallCheck2["default"])(this, Feature);
    this.name = name;
    this.activationCode = activationCode;
    this.userId = userId; // this.userPassword = userPassword

    this.additionalData = additionalData;
    console.log('created Feature', this);
  }

  (0, _createClass2["default"])(Feature, [{
    key: "toJson",
    value: function toJson() {
      return {
        name: this.name,
        activationCode: this.activationCode,
        userId: this.userId,
        // userPassword: this.userPassword,    // do not make persist password
        additionalData: this.additionalData
      };
    }
  }]);
  return Feature;
}();

Feature.fromJson = function (json) {
  if (!json || !json.name || !json.activationCode) {
    return null;
  }

  return new Feature(json.name, json.activationCode, json.userId, json.userPassword, json.additionalData);
};

var _default = Feature;
exports["default"] = _default;